module.exports = __webpack_public_path__ + "img/client-datacap.1dbd9dfa.svg";